<template>
  <div class="slider flex flex-col" :class="{'space-between':isDesktop}">
    <div class="slider__heading" :style="{'margin-bottom':headingMarginBottom}" :class="{'_desktop':isDesktop}" v-html="heading"></div>
    <div class="flex items-center space-between">
      <div class="value _min">{{min}}</div>
      <vue-slider ref="slider"
                  :value="value"
                  :tooltip="'always'"
                  :tooltip-formatter="tooltipFormatter"
                  :min="min"
                  :max="max"
                  @change="changeValue"
                  :class="{'w-full':isDesktop}"
      >
        <template v-slot:tooltip="{ value }">
          <div class="vue-slider-dot-tooltip-inner vue-slider-dot-tooltip-inner-top" :class="{'oval-border':value > 99}">
            <span class="vue-slider-dot-tooltip-text">{{ value }}</span>
          </div>
        </template>
      </vue-slider>
      <div class="value _max" :class="{'_extra':max > 99}" >{{max}}</div>
    </div>

  </div>
</template>
<script>
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'

  export default {
    props: {
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 100
      },
      heading: String,
      value: Array,
      headingMarginBottom: String,
      isDesktop: {
        type: Boolean,
        default: false
      },
      tooltipFormatter: {
        type: String,
        default: '{value}'
      }
    },
    components: {
      VueSlider
    },
    data() {
      return {
        newValue: []
      }
    },
    methods: {
      changeValue() {
        this.newValue = this.$refs.slider.getValue()
        this.$emit('changeValue', this.newValue)
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../../sass/variables';

  .slider {
    &__heading {
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 1.5;

      &._desktop {
        margin-right: -2.2rem;
        min-width: 7rem;
      }
    }

    &::v-deep .vue-slider {
      height: unset!important;
      width: 24rem !important;
    }

    & .value {
      font-size: 1.2rem;
      font-weight: 700;
      color: $textAndBorder;
      min-width: 2rem;

      &._min {
        margin-right: 1.8rem;
      }

      &._max {
        margin-left: 1.8rem;
        text-align: right;
        &._extra {
          /*margin-left: 2.5rem;*/
        }
      }
    }

    &::v-deep .vue-slider-rail {
      height: 1px;

      background-color: #C6C6C6;
      border-radius: initial;
    }

    &::v-deep .vue-slider-process {
      background-color: $textAndBorder;
      border-radius: initial;
    }

    &::v-deep .vue-slider-dot {
      width: 12px!important;
      height: 12px!important;
    }

    &::v-deep .vue-slider-dot-handle {
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
      background-color: $textAndBorder;
      border: none;
    }

    &::v-deep .vue-slider-dot-tooltip-top {
      top: 1.7rem;

      @media (min-width: $desktop-min-width) {
        top: 1.9rem;
      }
    }

    &::v-deep .vue-slider-process {
      background: $textAndBorder;
      height: 2px!important;
    }

    &::v-deep .vue-slider-dot-tooltip-inner {
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
      background-color: #07132F;
      border-radius: 2.7rem;
      min-height: 2.7rem;
      min-width: 2.7rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      color: $textAndBorder;
      padding: 0;

      &::after {
        display: none;
      }

      &.oval-border {
        border-radius: 2.7rem;
      }
    }

    &::v-deep .vue-slider-dot-tooltip-text {
      font-size: 1.2rem;
      font-weight: 700;
      color: #ffffff;
      padding: 0 7px;
    }
  }
</style>
